import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { type ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { RUNTIME_CONFIG, type RuntimeConfig } from './core/runtime-config';

/**
 * La configuration est passée en paramètre plutôt que lue depuis un module :
 * elle n'est connue qu'après le chargement de `config.json`, donc après le
 * démarrage du bundle.
 */
export function buildAppConfig(runtimeConfig: RuntimeConfig): ApplicationConfig {
  return {
    providers: [
      provideBrowserGlobalErrorListeners(),
      provideRouter(routes, withComponentInputBinding()),
      provideHttpClient(withInterceptors([authInterceptor])),
      { provide: RUNTIME_CONFIG, useValue: runtimeConfig },
    ],
  };
}
